
import { styleSheet } from "@matchlighter/common_library/lib/StyleSheet";
import { View } from "@instructure/ui-layout";

const styles = styleSheet(require('./Footer.module.scss'));

export const Footer: React.SFC = ({ children }) => {
    return <div className={styles('footer-wrapper')}>
        <View
            as="div"
            margin="0"
            padding="small"
            background="default"
            borderWidth="small none none none"
        >
            {children}
        </View>
    </div>
}
